var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98682 20.6308C9.72006 21.4699 10.7981 22 12 22C13.2019 22 14.28 21.4699 15.0132 20.6308C13.0178 20.9559 10.9822 20.9559 8.98682 20.6308Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5303 1.46967C22.8232 1.76256 22.8232 2.23744 22.5303 2.53033L2.53033 22.5303C2.23744 22.8232 1.76256 22.8232 1.46967 22.5303C1.17678 22.2374 1.17678 21.7626 1.46967 21.4697L21.4697 1.46967C21.7626 1.17678 22.2374 1.17678 22.5303 1.46967Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2912 18.8908C12.0141 19.6591 15.9191 19.2582 19.4519 17.6881C20.2954 17.3132 20.6552 16.3102 20.2424 15.4847L18.4224 11.8446C18.1447 11.2892 18.0001 10.6767 18.0001 10.0557V9.18188L8.2912 18.8908Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V3.08294C14.2121 3.28627 15.301 3.853 16.1507 4.66728L3.80222 17.0158C3.54197 16.5622 3.50504 15.9901 3.75778 15.4847L5.57782 11.8446C5.85553 11.2892 6.00011 10.6767 6.00011 10.0557V9C6.00011 6.02704 8.16234 3.5591 11 3.08298V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellMute);
export default __webpack_public_path__ + "static/media/bell-mute.6801f0eca4faccad337419464de86b79.svg";
export { ForwardRef as ReactComponent };